const CHANGE_EVENT = 'm-change';

export { CHANGE_EVENT };
